import type { EligiblePaymentMethod } from 'services/api/restful/generated/nofomoRestApi.schemas';

/** Query key prefix for tickets domain React Query keys. */
export const TICKETS_PREFIX = 'tickets';

export enum QueryParam {
  CkoPaymentId = 'cko-payment-id',
  ErrorState = 'error-state',
  Status = 'status',
}

export const TICKET_FILTERS_ALL = 'all_tickets_included';

export const TICKETS_CONFIRMATION_ORDER_STORAGE_KEY = 'nf-tickets-order-id';
export const MAX_CART_ITEMS = 20;
export const DEFAULT_CURRENCY = 'SAR';
export const AED_CURRENCY = 'AED';
export const TICKET_SHARE_CODE_KEY = 'nf-tickets-share-code';
export const APPLE_PAY_VERSION = 13;

export const paymentMethodIntlIdLookup: Record<EligiblePaymentMethod, string> =
  {
    ApplePay: 'checkout.payment.method.apple.pay',
    CreditCard: 'checkout.payment.method.credit.card',
    TabbyPay: 'checkout.payment.method.tabby',
    TamaraPay: 'checkout.payment.method.tamara',
  };

export const TAMARA_MIN_ORDER_AMOUNT = 99;

export type TamaraSupportedCountryCode = 'SA' | 'AE';

export const TamaraSupportedCountryCodes: ReadonlyArray<TamaraSupportedCountryCode> =
  ['SA', 'AE'];

export const TamaraPhoneCountryCallingCodes = ['966', '971'] as const;

export type TabbySupportedCountryCode = 'SA' | 'AE';
type TabbySupportedCurrency = 'SAR' | 'AED';

type TabbyCountryCurrencyMapping = Record<
  TabbySupportedCountryCode,
  {
    countryCode: TabbySupportedCountryCode;
    currency: TabbySupportedCurrency;
    tabbySupported: boolean;
  }
>;

export const TabbyCountriesAndCurrenciesMapping: TabbyCountryCurrencyMapping = {
  SA: {
    countryCode: 'SA',
    currency: DEFAULT_CURRENCY,
    tabbySupported: true,
  },
  AE: {
    countryCode: 'AE',
    currency: AED_CURRENCY,
    tabbySupported: true,
  },
} as const;

export type TransferStep = 1 | 2 | 3;

export const STEP_SELECT: TransferStep = 1;
export const STEP_TRANSFER: TransferStep = 2;
export const STEP_CONFIRM: TransferStep = 3;

export const TRANSFER_SCANNABLES_LIMIT = 150;
